/**
 * Small geometry/label helpers shared by the board's horizontal strips (accommodation + services).
 */
import type { TFunction } from 'i18next';

/**
 * Localized "Den N" / "Noc N" range label for a span starting at `from` (0-based) covering `span` units.
 * `kind` picks the day vs. night word (and its plural).
 */
export function spanLabel(t: TFunction, from: number, span: number, kind: 'day' | 'night'): string {
  const single = kind === 'night' ? t('costScheme.night') : t('costScheme.day');
  if (span <= 1) return `${single} ${from + 1}`;
  const plural = kind === 'night' ? t('costScheme.nights') : t('costScheme.days');
  return `${plural} ${from + 1}–${from + span}`;
}

/**
 * Right-edge x coordinates of every day-head cell in the grid, read from the DOM. The strip resize logic
 * snaps the dragged edge to the nearest of these boundaries. Reads live layout because collapsed days and
 * lane widths make the columns non-uniform.
 */
export function headRightsOf(rowRef: React.RefObject<HTMLDivElement | null>): number[] {
  const grid = rowRef.current?.parentElement;
  const heads = grid ? grid.querySelectorAll('.tp-day-head') : [];
  return Array.from(heads).map((h) => h.getBoundingClientRect().right);
}
